import request from '@/lib/request/'

const baseUri = 'type'

/**
 * @returns {Promise}
 */
export function getWorkMediaType () {
  return request({
    url: `${baseUri}/work-media-type`,
    method: 'get'
  })
}

/**
 * @returns {Promise}
 */
export function getWorkProjectType () {
  return request({
    url: `${baseUri}/work-project-type`,
    method: 'get'
  })
}

/**
 * @returns {Promise}
 */
export function getStoriesTag () {
  return request({
    url: `${baseUri}/stories-tag`,
    method: 'get'
  })
}

/**
 * @returns {Promise}
 */
export function getStoriesProjectType () {
  return request({
    url: `${baseUri}/stories-project-type`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/type/index.js